// src/components/FAQSection.jsx
import React, { useState } from 'react';
import { Container, Row, Col, Accordion, useAccordionButton, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom'; // Para el enlace de contacto
import './FAQSection.css'; // Crearemos este archivo para los estilos

// Componente personalizado para el Header del Acordeón para controlar el ícono
function CustomAccordionToggle({ children, eventKey, activeEventKey, callback }) {
    const isCurrentEventKey = activeEventKey === eventKey;

    const decoratedOnClick = useAccordionButton(eventKey, () =>
        callback && callback(eventKey)
    );

    return (
        <Card.Header
            onClick={decoratedOnClick}
            className={`faq-accordion-header ${isCurrentEventKey ? 'active' : ''}`}
            style={{ cursor: 'pointer' }}
        >
            {children}
            <FontAwesomeIcon icon={isCurrentEventKey ? faChevronUp : faChevronDown} className="ms-auto accordion-icon" />
        </Card.Header>
    );
}

const FAQSection = () => {
    const appName = "MyFit Menu AI"; // O el nombre de tu app
    const [activeKey, setActiveKey] = useState("0"); // Estado para saber qué item está activo

    const faqs = [
        {
            eventKey: "0",
            question: `How does ${appName} personalize my meal and workout plans?`,
            answer: `${appName} uses advanced AI algorithms that consider your unique profile data (age, weight, height, sex, activity level), your specific health goals (e.g., weight loss, muscle gain), dietary preferences, and any listed allergies or restrictions. This allows us to generate plans that are truly tailored to you.`
        },
        {
            eventKey: "1",
            question: "Is the nutritional information from the food scanner accurate?",
            answer: `Our food scanner utilizes comprehensive databases for barcode scanning (like Open Food Facts) and powerful AI for image analysis. While we strive for the highest accuracy, AI interpretations can sometimes vary. We always recommend cross-referencing critical information if you have severe allergies or medical conditions.`
        },
        {
            eventKey: "2",
            question: "Can I adjust my calorie and macro targets after they're calculated?",
            answer: `Absolutely! ${appName} provides initial AI-calculated targets as a strong starting point. However, you have full control to adjust your daily calorie intake and macronutrient percentages (protein, carbs, fat) at any time to better suit your evolving needs or preferences.`
        },
        {
            eventKey: "3",
            question: "How are the workout routines generated?",
            answer: `Similar to meal plans, our AI considers your fitness level, goals (e.g., strength, endurance), available time, and any preferences you've shared. Routines are designed to be effective and progressive, helping you achieve your fitness targets safely.`
        },
        {
            eventKey: "4",
            question: "What if I have specific dietary needs like vegan, gluten-free, or allergies?",
            answer: `During your profile setup (and editable later), you can specify these dietary preferences and restrictions. ${appName}'s AI will then ensure that all generated meal plans and recipes strictly adhere to your stated needs.`
        },
        {
            eventKey: "5",
            question: `Is ${appName} free to use?`,
            answer: `You can get started with ${appName} for free to experience our core features, including initial AI analysis and access to some personalized content. We also offer premium subscription plans that unlock advanced features, more extensive personalization, and a wider range of recipes and workout routines.`
        }
    ];

    return (
        <section className="py-5"> {/* Fondo claro para esta sección */}
            <Container>
                <Row className="text-center mb-5">
                    <Col>
                        <FontAwesomeIcon icon={faQuestionCircle} size="3x" className="text-primary mb-3" />
                        <h2 className="fw-bold display-5">Frequently Asked Questions</h2>
                        <p className="text-muted fs-5">
                            Your common questions answered. Can't find what you're looking for? <Link to="/contact">Reach out to us!</Link>
                        </p>
                    </Col>
                </Row>
                <Row className="justify-content-center">
                    <Col md={10} lg={8}>
                        <Accordion activeKey={activeKey} onSelect={(k) => setActiveKey(k)} flush={false}> {/* flush={false} para bordes */}
                            {faqs.map((faq) => (
                                <Card key={faq.eventKey} className="faq-item mb-3 shadow-sm">
                                    <CustomAccordionToggle eventKey={faq.eventKey} activeEventKey={activeKey}>
                                        <span className="fw-semibold fs-5 faq-question-text">{faq.question}</span>
                                    </CustomAccordionToggle>
                                    <Accordion.Collapse eventKey={faq.eventKey}>
                                        <Card.Body className="faq-answer-text">
                                            {faq.answer}
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                            ))}
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default FAQSection;